// This allows us to lazyload images by adding the "lazyload" CSS class to an <img>, <div>, or other HTML elements.
// See their docs for usage info: https://github.com/aFarkas/lazysizes
import 'lazysizes';

// Support for background images
// https://github.com/aFarkas/lazysizes#js-api---events
document.addEventListener('lazybeforeunveil', function (e) {
    const bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});
